
import React from 'react';
import FormInputTagsItem from './FormInputTagsItem';
import VendorSearch from '../../search/VendorSearch';

export default (props) => {
  return <FormInputTagsItem {...props} inputComponent={VendorSearch} />;
};
